<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>关联账号</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <el-row
                :gutter="20"
                type="flex"
                class="row-bg"
                justify="space-around"
            >
                <el-col :span="16">
                    <div class="contentBox">
                        <div class="tagView">
                            <div class="title_aside"></div>
                            <el-breadcrumb
                                separator-class="el-icon-arrow-right"
                            >
                                <el-breadcrumb-item>账号</el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                        <div class="mes">
                            用于登录和验证身份，同时也是您个人信息的一部分。如有更换，请及时更新。
                        </div>
                        <el-divider></el-divider>
                        <div class="tel">
                            <div
                                class="imgSrc"
                                :style="{
                                    backgroundImage: 'url(' + imgSrc1 + ')',
                                }"
                            ></div>
                            <p>
                                手机号<b
                                    :class="!userdata.phone ? 'isEmail' : ''"
                                    >{{ userdata.phone || "(未绑定)" }}</b
                                >
                            </p>
                            <el-button
                                round
                                v-if="userdata.phone"
                                @click="isBang('phone')"
                                >更换</el-button
                            >
                            <el-button round v-else @click="bang('phone', 'b')"
                                >绑定</el-button
                            >
                        </div>
                        <el-divider></el-divider>
                        <div class="tel">
                            <div
                                class="imgSrc"
                                :style="{
                                    backgroundImage: 'url(' + imgSrc2 + ')',
                                }"
                            ></div>
                            <p>
                                邮箱<b
                                    :class="!userdata.email ? 'isEmail' : ''"
                                    >{{ userdata.email || "(未绑定)" }}</b
                                >
                            </p>
                            <el-button
                                round
                                v-if="userdata.email"
                                @click="isBang('email')"
                                >更换</el-button
                            >
                            <el-button round v-else @click="bang('email', 'b')"
                                >绑定</el-button
                            >
                        </div>
                    </div>
                </el-col>
            </el-row>

            <el-row
                :gutter="20"
                type="flex"
                class="row-bg bot"
                justify="space-around"
            >
                <el-col :span="16">
                    <div class="contentBox">
                        <div class="tagView">
                            <div class="title_aside"></div>
                            <el-breadcrumb
                                separator-class="el-icon-arrow-right"
                            >
                                <el-breadcrumb-item>绑定</el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                        <div class="tel">
                            <div
                                class="imgSrc"
                                :style="{
                                    backgroundImage: 'url(' + imgSrc3 + ')',
                                }"
                            ></div>
                            <p>微信</p>
                            <el-button
                                round
                                @click="unbind('wechat')"
                                v-if="thirdlist.wechat"
                                >解绑</el-button
                            >
                            <el-button round @click="thirdbind('wechat')" v-else
                                >绑定</el-button
                            >
                        </div>
                        <el-divider></el-divider>
                        <div class="tel">
                            <div
                                class="imgSrc"
                                :style="{
                                    backgroundImage: 'url(' + imgSrc4 + ')',
                                }"
                            ></div>
                            <p>QQ</p>
                            <el-button
                                round
                                @click="unbind('qq')"
                                v-if="thirdlist.qq"
                                >解绑</el-button
                            >
                            <el-button round @click="thirdbind('qq')" v-else
                                >绑定</el-button
                            >
                        </div>
                        <el-divider></el-divider>
                        <div class="tel">
                            <div
                                class="imgSrc"
                                :style="{
                                    backgroundImage: 'url(' + imgSrc5 + ')',
                                }"
                            ></div>
                            <p>微博</p>
                            <el-button
                                round
                                @click="unbind('weibo')"
                                v-if="thirdlist.weibo"
                                >解绑</el-button
                            >
                            <el-button round @click="thirdbind('weibo')" v-else
                                >绑定</el-button
                            >
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        
        <!-- 验证旧号码 -->
        <el-dialog
            :title="titlejiu"
            :visible.sync="dialogphonejiu"
            width="480px"
            top="27vh"
            class="copyDialog copyDialog3"
            center
            :before-close="handlejiu"
            :close-on-click-modal="false"
        >
            <el-row :gutter="20" type="flex" class="row-bg" justify="center">
                <el-col :span="20">
                    <p>为确保是您本人操作，请进行身份验证。</p>
                    <p class="yzphone">
                        {{
                            xinyzm.loginType == 1
                                ? userdata.phone
                                : userdata.email
                        }}
                    </p>

                    <el-form
                        :model="jiuyzm"
                        :rules="rulesyzm1"
                        ref="jiuyzm"
                        status-icon
                        label-width="0px"
                        class="demo-ruleForm"
                    >
                        <el-form-item prop="yzm1">
                            <el-input
                                type="text"
                                v-model="jiuyzm.yzm1"
                                autocomplete="off"
                                clearable
                                class="copyDialog3Code"
                                placeholder="请输入验证码"
                            >
                                <span
                                    slot="append"
                                    class="yzm"
                                    :disabled="disabled"
                                    @click="
                                        getVerificationCode(
                                            xinyzm.loginType == 1
                                                ? 'phone'
                                                : 'email',
                                            1
                                        )
                                    "
                                    >{{ yzmtext }}</span
                                >
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <div class="changeBind" v-if="userdata.parentId=='0'">
                <span @click="openChangeBind">{{xinyzm.loginType == 1 ?'该手机号已无法收取验证码':'该邮箱已无法收取验证码'}}</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="subjiuyzm('jiuyzm')"
                    >下一步</el-button
                >
                <el-button round class="next" @click="handlejiu"
                    >取消</el-button
                >
            </span>
        </el-dialog>
        <!-- 绑定新号码 -->
        <el-dialog
            :title="titlexin"
            :visible.sync="dialogphonexin"
            width="480px"
            top="27vh"
            class="copyDialog copyDialog3"
            :close-on-click-modal="false"
            :before-close="handlexin"
            center
        >
            <el-row :gutter="20" type="flex" class="row-bg" justify="center">
                <el-col :span="20">
                    <el-form
                        :model="xinyzm"
                        status-icon
                        :rules="rulesyzm2"
                        ref="xinyzm"
                        label-width="0px"
                        class="demo-ruleForm"
                    >
                        <el-form-item prop="loginName">
                            <el-input
                                class="copyDialog3ipt"
                                v-model="xinyzm.loginName"
                                autocomplete="off"
                                :placeholder="[
                                    xinyzm.loginType == 1
                                        ? '请输入要绑定的手机号'
                                        : '请输入要绑定的邮箱',
                                ]"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="yzm1">
                            <el-input
                                type="text"
                                v-model="xinyzm.yzm1"
                                autocomplete="off"
                                clearable
                                placeholder="请输入验证码"
                                class="copyDialog3Code"
                            >
                                <span
                                    class="yzm"
                                    slot="append"
                                    :disabled="disabled"
                                    @click="
                                        getVerificationCode(
                                            xinyzm.loginType == 1
                                                ? 'phone'
                                                : 'email',
                                            2
                                        )
                                    "
                                    >{{ yzmtext }}</span
                                >
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="subxinyzm('xinyzm')"
                    >绑定</el-button
                >
                <el-button round class="next" @click="handlexin"
                    >取消</el-button
                >
            </span>
        </el-dialog>
        <!-- 换绑协议 -->
        <el-dialog
            title="换绑协议"
            :visible.sync="dialoghuanbang"
            width="480px"
            top="27vh"
            class="copyDialog copyDialog3"
            center
            :before-close="handlejiu"
            :close-on-click-modal="false"
        >
            <el-row :gutter="20" type="flex" class="row-bg" justify="center">
                <el-col :span="20">
                    <p style="margin:0">尊敬的用户:</p>
                    <p>
                        在您申请更换与您平台注册账户绑定的手机号码、邮箱账户前，请务必知悉：
                        您申请更换绑定的手机号码、邮箱账户后，原来的手机号码和邮箱账户将无法用于登录、密码找回、接收平台发送的信息，无法使用更换前的手机号码、邮箱账户进行与您平台账号相关的一切操作。
                        更换绑定手机号码和邮箱账户，不影响账户中的数据、账户内的剩余服务次数。
                    </p>
                    <p style="text-align:right">北京联合信任技术服务有限公司</p>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button
                    round
                    type="primary"
                    @click="nextSet"
                    >下一步</el-button
                >
                <el-button round class="next" @click="dialoghuanbang = false"
                    >取消</el-button
                >
            </span>
        </el-dialog>
        <!-- 无原手机号重新绑定逻辑 -->
        <ChangePhone v-if="isChangePhoneBind" @closeProcess="isChangePhoneBind=false" @updateUserInfo="creatrequest" />
        <!-- 无原手机号重新绑定邮箱逻辑 -->
        <ChangeEmail v-if="isChangeEmailBind" @closeProcess="isChangeEmailBind=false" @updateUserInfo="creatrequest" />
        <div id="captcha-element"></div>
    </el-row>
</template>

<script>
import { mapState } from "vuex";
import { GetRequest } from "@/utils/filter";
import qs from "qs";
import ChangePhone from "@/components/UserCenter/ChangePhone";
import ChangeEmail from "@/components/UserCenter/ChangeEmail";
import { getStatusByType } from "@http/userCenter/index";
import { sendMsg,verifyPhoneAuthentication,emailByAuthentication,changeBindApply,refreshToken} from "@http/userCenter/index";
import NoTrace from '@/utils/noTrace';
let interval = null;
let time = 61;
export default {
    name: "association",
    data() {
        var validateyzm1 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入验证码"));
            }
            if (value.trim().length == 0) {
                callback(new Error("验证码不能为空"));
            }
            if (this.msg) {
                callback(new Error(this.msg));
            }
            callback();
        };
        var vloginName = (rule, value, callback) => {
            if (this.xinyzm.loginType == 1) {
                var phone = this.xinyzm.loginName;
                if (!/^1[23456789]\d{9}$/.test(phone)) {
                    callback(new Error("手机号格式不正确"));
                }
            } else {
                var reg = new RegExp(
                    "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
                );
                if (!reg.test(this.xinyzm.loginName)) {
                    callback(new Error("邮箱格式不正确"));
                }
            }
            if (this.msg) {
                callback(new Error(this.msg));
            }
            callback();
        };
        return {
            imgSrc1: require("@/assets/images/user/phone1-1.png"),
            imgSrc2: require("@/assets/images/user/email1-1.png"),
            imgSrc3: require("@/assets/images/user/wx1-1.png"),
            imgSrc4: require("@/assets/images/user/qq1-1.png"),
            imgSrc5: require("@/assets/images/user/wb1-1.png"),
            changeUser: require("@/assets/images/user/changeUser.png"),
            dialoghuanbang: false, //换绑协议
            thirdlist: {
                wechat: "",
                qq: "",
                weibo: "",
            },
            msg: false,
            signupType: "",
            titlejiu: "验证身份",
            titlexin: "绑定手机号",
            dialogphonejiu: false,
            dialogphonexin: false,
            yzmtext: "获取验证码",
            disabled: false,
            currentTime: 61,
            loginState: "",
            jiuyzm: {
                loginName: "",
                yzm1: "",
            },
            xinyzm: {
                loginType: 1,
                yzm1: "",
                loginName: "",
            },
            rulesyzm1: {
                yzm1: [{ validator: validateyzm1 }],
            },
            rulesyzm2: {
                yzm1: [{ validator: validateyzm1 }],
                loginName: [{ validator: vloginName }],
            },
            sucyzm: "",
            type: "", //方式 h：更换 b:绑定
            ruleForm: {},
            isChangePhoneBind:false, //是否需要重新绑定手机号
            isChangeEmailBind:false,//是否需要重新绑定邮箱
        };
    },
    components: {ChangePhone,ChangeEmail},
    computed: {
        ...mapState({
            // userdata: (state) => state.userInfo.userinfo,
        }),
        userdata: {
            get() {
                return this.$store.state.userInfo.userinfo;
            },
            set(val) {
                this.$store.state.userInfo.userinfo = val;
            },
        },
        channelCodeValue(){
            return this.$store.state.config.channelCodeValue;
        },
    },
    created() {
        this.bindlist();
    },
    mounted() {
        zhuge.track('用户中心_进入关联账号页', {'渠道': this.channelCodeValue})
        NoTrace.init('captcha-element', 'captcha-button')
    },
    beforeDestroy() {
        NoTrace.reset()
    },
    methods: {
        bindlist() {
            let that = this;
            this.$reqCenter({
                method: "post",
                url: "/third/bind/list",
            })
                .then((res) => {
                    console.log(res);
                    that.thirdlist = res;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        creatrequest() {
            this.$reqCenter({
                method: "post",
                url: "/me",
            })
                .then((res) => {
                    console.log(res);
                    this.$store.commit("userInfo/setuserinfo", res);
                    this.userdata = res;
                })
                .catch((err) => {
                    console.log(err);set
                });
        },
        getVerificationCode(e, n) {
            let data;
            if (n == 2) {
                if (this.xinyzm.loginType == 1) {
                    var phone = this.xinyzm.loginName;
                    if (!/^1[23456789]\d{9}$/.test(phone)) {
                        return false;
                    }
                } else {
                    var reg = new RegExp(
                        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
                    );
                    if (!reg.test(this.xinyzm.loginName)) {
                        return false;
                    }
                }
                if (e == "phone") {
                    data = {
                        loginName: this.xinyzm.loginName,
                        signupType: "PHONE",
                    };
                } else {
                    data = {
                        loginName: this.xinyzm.loginName,
                        signupType: "EMAIL",
                    };
                }
            } else {
                if (e == "phone") {
                    data = {
                        loginName: this.userdata.phone,
                        signupType: "PHONE",
                    };
                } else {
                    data = {
                        loginName: this.userdata.email,
                        signupType: "EMAIL",
                    };
                }
            }
            this.getCode();
            var that = this;
            that.disabled = true;
            
            // 开始获取无痕验证码
            NoTrace.start((nvc) => {
                this.nvc = nvc
            }, this.executeFun, {
                ...data,
                nvc: '',
                afsVersion: 2
            })
        },
        executeFun (params) {
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await sendMsg(params);
                    resolve(res)
                    that.$msg("验证码已发送，请注意接收", "success");
                }catch (err) {
                    reject(err)
                    that.$msg("发送失败");
                    that.disabled = false;
                    clearInterval(interval);
                    that.yzmtext = "重新获取";
                    that.currentTime = time;
                }
            })
        },

        getCode() {
            var that = this;
            var currentTime = that.currentTime;
            interval = setInterval(function() {
                currentTime--;
                that.yzmtext = "(" + currentTime + "s)重新获取";
                if (currentTime <= 0) {
                    clearInterval(interval);
                    that.yzmtext = "重新获取";
                    that.currentTime = time;
                    that.disabled = false;
                }
            }, 1000);
        },
        // 是否绑定 协议
        isBang(type) {
            getStatusByType(type == 'phone' ? 0 : 1).then(res => {
                if(res.status==0){
                    this.$router.push({
                        path: '/userCenter/changeBindApply',
                        query:{
                            type: type == 'phone' ==1 ? 0 : 1
                        }
                    });
                }else{
                    if (this.userdata.phone && type === "phone") {
                        this.huan("phone", "h");
                        zhuge.track('用户中心_换绑手机', {'渠道': this.channelCodeValue})
                    } else if (this.userdata.email && type === "email") {
                        this.huan("email", "h");
                        zhuge.track('用户中心_换绑邮箱', {'渠道': this.channelCodeValue})
                    }
                }
            }).catch(err => {
                this.$msg(err.message)
            });
        },
        huan(e, type) {
            this.jiuyzm.yzm1 = "";
            this.xinyzm.loginName = "";
            this.xinyzm.yzm1 = "";
            this.dialoghuanbang = true;
            this.type = type;
            clearInterval(interval);
            this.currentTime = time;
            this.disabled = false;
            this.yzmtext = "获取验证码";
            if (e == "phone") {
                this.titlejiu = "验证身份";
                this.titlexin = "绑定新手机号";
                this.xinyzm.loginType = 1;
            } else {
                this.titlejiu = "验证身份";
                this.titlexin = "绑定新邮箱";
                this.xinyzm.loginType = 2;
            }
            this.$nextTick(() => {
                if(this.$refs.captcha1){
                    this.$refs.captcha1.innerHTML = "";
                }
            });
            this.jiuyzm.loginName =
                this.xinyzm.loginType == 1
                    ? this.userdata.phone
                    : this.userdata.email;
        },
        bang(e, type) {
            this.dialogphonexin = true;
            this.type = type;
            clearInterval(interval);
            this.currentTime = time;
            this.disabled = false;
            this.yzmtext = "获取验证码";
            if (e == "phone") {
                this.titlexin = "绑定手机号";
                this.xinyzm.loginType = 1;
                zhuge.track('用户中心_绑定手机', {'渠道': this.channelCodeValue})
            } else {
                this.titlexin = "绑定邮箱";
                this.xinyzm.loginType = 2;
                zhuge.track('用户中心_绑定邮箱', {'渠道': this.channelCodeValue})
            }
            this.$nextTick(() => {
                if(this.$refs.captcha2){
                    this.$refs.captcha2.innerHTML = "";
                }
            });
        },
        nextSet(){
            this.dialogphonejiu = true;
            this.dialoghuanbang = false;
            this.$nextTick(() => {
                this.$refs["jiuyzm"].resetFields();
                this.$refs["jiuyzm"].clearValidate();
            });
        },
        handlejiu() {
            this.dialogphonejiu = false;
            this.dialoghuanbang = false;
        },
        handlexin() {
            this.$refs["xinyzm"].resetFields();
            this.$refs["xinyzm"].clearValidate();
            this.dialogphonexin = false;
            this.dialoghuanbang = false;
        },
        subjiuyzm(jiuyzm) {
            let that = this;
            this.$refs[jiuyzm].validate((valid) => {
                if (valid) {
                    that.$reqCenter({
                        method: "post",
                        data: qs.stringify({
                            loginName: that.jiuyzm.loginName,
                            code: that.jiuyzm.yzm1,
                        }),
                        url: "/verifyCode",
                    })
                        .then((res) => {
                            console.log(res);
                            this.yzmtext = "获取验证码";
                            this.disabled = false;
                            this.currentTime = 61;
                            this.dialogphonejiu = false;
                            this.dialogphonexin = true;
                            clearInterval(interval);
                            this.$nextTick(() => {
                                this.$refs.captcha1.innerHTML = "";
                                // this.$refs.xinyzm.resetFields();
                            });
                        })
                        .catch((err) => {
                            console.log(err);
                            that.msg = err.message;
                            that.$refs.jiuyzm.validateField("yzm1");
                            that.msg = false;
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        subxinyzm(xinyzm) {
            var that = this;
            if(that.xinyzm.loginType== 1){
                if(this.titlexin == "绑定新手机号"){
                    zhuge.track('用户中心_提交换绑手机', {'渠道': this.channelCodeValue})
                }
            }else{
                if(this.titlexin == "绑定新邮箱"){
                    zhuge.track('用户中心_提交换绑邮箱', {'渠道': this.channelCodeValue})
                }
            }
            this.$refs[xinyzm].validate((valid) => {
                if (valid) {
                    var urlrequest;
                    var data;
                    if (that.type == "h") {
                        if (that.xinyzm.loginType == 1) {
                            urlrequest = "/change/bind/phone";
                            data = {
                                newPhone: that.xinyzm.loginName,
                                newPhoneCode: that.xinyzm.yzm1,
                                oldPhone: that.jiuyzm.loginName,
                                oldPhoneCode: that.jiuyzm.yzm1,
                            };
                        } else {
                            urlrequest = "/change/bind/email";
                            data = {
                                newMail: that.xinyzm.loginName,
                                newMailCode: that.xinyzm.yzm1,
                                oldMail: that.jiuyzm.loginName,
                                oldMailCode: that.jiuyzm.yzm1,
                            };
                        }
                    } else {
                        if (that.xinyzm.loginType == 1) {
                            urlrequest = "/bind/phone";
                        } else {
                            urlrequest = "/bind/email";
                        }
                        data = {
                            loginName: that.xinyzm.loginName,
                            code: that.xinyzm.yzm1,
                        };
                    }
                    var loading = this.$layer.loading({
                        shade: true,
                    });
                    that.$reqCenter({
                        method: "post",
                        data: qs.stringify(data),
                        url: urlrequest,
                    })
                        .then((res) => {
                            console.log(res);
                            that.yzmtext = "获取验证码";
                            that.disabled = false;
                            that.currentTime = time;
                            that.dialogphonejiu = false;
                            that.$reqCenter({
                                method: "post",
                                url: "/refreshToken",
                            })
                                .then((res) => {
                                    console.log(res);
                                    that.dialogphonejiu = false;
                                    that.dialogphonexin = false;
                                    that.jiuyzm = {
                                        loginName: "",
                                        yzm1: "",
                                    };
                                    that.xinyzm = {
                                        loginType: 1,
                                        yzm1: "",
                                        loginName: "",
                                    };
                                    that.$layer.close(loading);
                                    let redirectUrl = that.$getlocalStorage(
                                        "queryData"
                                    )
                                        ? that.$getlocalStorage("queryData")
                                              .redirectUrl
                                        : "";
                                    if (redirectUrl) {
                                        localStorage.removeItem("queryData");
                                        window.location.href =decodeURI(redirectUrl)
                                    } else {
                                        that.creatrequest();
                                    }
                                })
                                .catch((err) => {
                                    console.log(err);
                                    that.$layer.close(loading);
                                });
                        })
                        .catch((err) => {
                            console.log(err);
                            if (err.code == 1) {
                                that.dialogphonejiu = true;
                                that.dialogphonexin = false;
                                that.msg = err.message;
                                that.$refs.jiuyzm.validateField("yzm1");
                                that.msg = false;
                            }else if (err.code == 2) {//绑定新手机号或邮箱，验证码不正确
                                that.dialogphonejiu = false;
                                that.dialogphonexin = true;
                                that.msg = err.message;
                                that.$refs.xinyzm.validateField("yzm1");
                                that.msg = false;
                            }else if (err.code == 3) {//手机号或邮箱已绑定其他账号
                                that.dialogphonejiu = false;
                                that.dialogphonexin = true;
                                that.msg = err.message;
                                that.$refs.xinyzm.validateField("loginName");
                                that.msg = false;
                            }else if(err.code==403){
                                if(urlrequest = "/bind/email" && err.message!=='验证码错误'){//邮箱已经绑定,请勿重复绑定
                                    that.msg=err.message;
                                    that.$refs.xinyzm.validateField("loginName");
                                    that.msg=false;
                                }else{//绑定邮箱或手机号验证码错误
                                    that.msg=err.message;
                                    that.$refs.xinyzm.validateField("yzm1");
                                    that.msg=false;
                                }
                            }else{ //手机号或邮箱已绑定其他账号
                                that.msg=err.message;
                                that.$refs.xinyzm.validateField("loginName");
                                that.msg=false;
                            }
                            // if(err.code==403){
                            //     that.dialogphonexin=true;
                            //     that.msg=err.message;
                            //     that.$refs.xinyzm.validateField("loginName");
                            //     that.msg=false;
                            // }
                            // this.$msg(err.message);
                            that.$layer.close(loading);
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        thirdbind(platformType) {
            let that = this;
            if(platformType=='wechat'){
                zhuge.track('用户中心_绑定微信', {'渠道': this.channelCodeValue})
            }else if(platformType=='qq'){
                zhuge.track('用户中心_绑定QQ', {'渠道': this.channelCodeValue})
            }else{
                zhuge.track('用户中心_绑定微博', {'渠道': this.channelCodeValue})
            }
            that.$setlocalStorage("platformType", platformType);
            that.$setlocalStorage("islogin", true);
            that.$reqCenter({
                method: "get",
                url: `/third/render/${platformType}`,
            }).then((res) => {
                let obj = GetRequest(res.redirectUrl);
                let host = res.redirectUrl.split("?")[0];
                obj.state = obj.state + "_" + platformType + "_account";
                console.log(host + "?" + qs.stringify(obj));
                window.location.href = host + "?" + qs.stringify(obj);
            }).catch((err) => {
                console.log(err);
            });
        },
        unbind(platformType) {
            let that = this;
            if(platformType=='wechat'){
                zhuge.track('用户中心_解绑微信', {'渠道': this.channelCodeValue})
            }else if(platformType=='qq'){
                zhuge.track('用户中心_解绑QQ', {'渠道': this.channelCodeValue})
            }else{
                zhuge.track('用户中心_解绑微博', {'渠道': this.channelCodeValue})
            }
            that.$setlocalStorage("platformType", platformType);
            this.$confirm(
                "此操作将解除与该第三方的账户绑定, 是否继续?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    that.$setlocalStorage("platformType", platformType);
                    that.$reqCenter({
                        method: "delete",
                        url: `/third/unbind/${platformType}`,
                    })
                        .then((res) => {
                            console.log(res);
                            that.$msg(
                                "本账号与该第三方账号已解除绑定",
                                "success"
                            );
                            that.bindlist();
                        })
                        .catch((err) => {
                            console.log(err);
                            localStorage.Item("platformType");
                        });
                })
                .catch(() => {
                    localStorage.removeItem("platformType");
                });
        },
        openChangeBind(){
            getStatusByType(this.xinyzm.loginType ==1 ? 0 : 1).then(res => {
                if(res.status==0){
                    this.$router.push({
                        path: '/userCenter/changeBindApply',
                        query:{
                            type: this.xinyzm.loginType ==1 ? 0 : 1
                        }
                    });
                }else{
                    this.dialogphonejiu=false;
                    if(this.xinyzm.loginType ==1){
                        this.isChangePhoneBind=true;
                        zhuge.track('用户中心_手机收不到验证码', {'渠道': this.channelCodeValue})
                    }else{
                        this.isChangeEmailBind=true;
                        zhuge.track('用户中心_邮箱收不到验证码', {'渠道': this.channelCodeValue})
                    }
                }
            }).catch(err => {
                this.$msg(err.message)
            });
        }
    },
};
</script>

<style lang="less" scoped>
.isEmail {
    color: red;
}
.bot {
    margin-top: 20px;
}

.contentBox {
    background: #ffffff;
    border: 1px solid #e8e8e8;
    padding: 18px 22px;
    padding-bottom: 12px;
    box-shadow: -4px 4px 6px 0px rgba(172, 172, 172, 0.18);
    .mes {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 35px;
        margin-left: 17px;
    }

    /deep/ .el-divider--horizontal {
        margin: 5px auto;
        width: 96%;
    }

    .tel {
        margin-top: 21px;
        height: 60px;
        padding-left: 18px;
        padding-right: 15px;

        .imgSrc {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            float: left;
            margin-right: 10px;
        }

        p {
            float: left;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333;
            margin-top: 10px;
        }

        .el-button {
            padding: 11px 42px;
            border-color: #3f7df7;
            float: right;
            color: #3f7df7;
        }
    }
}

.copyDialog {
    .headerImg {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin: auto;
    }

    .changeUser {
        width: 24px;
        height: 22px;
    }

    .el-col-3 {
        display: flex;
        justify-content: center;
        align-self: center;
    }

    p {
        margin-top: 10px;
        text-align: left;
    }

    .yzphone {
        margin-bottom: 15px;
    }

    .el-button {
        padding: 12px 23px;
        margin: auto;
        background: #3f7df7;
    }

    .demo-ruleForm {
        p {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #3f7df7;
            line-height: 35px;
            cursor: pointer;
        }
    }
    .changeBind{
        text-align: center;
        span{
            color: #3f7df7;
            cursor: pointer;
        }
    }
}

.copyDialog2,
.copyDialog3 {
    /deep/ .el-dialog__body {
        padding-bottom: 0;
    }

    .next {
        background: #fff;
        margin-left: 20px;
    }
}

.copyDialog3 {
    .copyDialog3Code {
        /deep/ .el-input__inner {
            border-radius: 22px 0 0 22px;
        }

        /deep/ .el-input-group__append {
            border-radius: 0 22px 22px 0;
            cursor: pointer;
            padding: 0;
        }

        /deep/ .el-input-group__append .yzm {
            display: block;
            padding: 0 20px;
            color: #3f7df7;
        }

        /deep/ .el-input-group__append .yzm[disabled] {
            color: #c8c8c8;
            pointer-events: none;
        }
    }
    .copyDialog3ipt {
        /deep/ .el-input__inner {
            border-radius: 22px;
        }
    }

    /deep/ .el-dialog__footer {
        padding-bottom: 39px;
        padding-top: 28px;
    }
}

b {
    margin-left: 10px;
}

.el-input-group__append {
    .el-button {
        padding: 12px 20px;
        background: none;
    }
}
.sm-pop-inner {
    position: static;
}
</style>
<style></style>
